export class FirstLoginDto {
    userName: string;
    currentPassword: string;
    password: string;
    recoveryQuestions: string[];
    recoveryAnswers: string[];
}
